export default "__VITE_ASSET__JCaTITzL__"